import React, { useEffect, useState } from "react";
import Axios from "axios";
import Constants from "../Constants";
import {
	Box,
	Button,
	Card,
	CircularProgress,
	Dialog,
	IconButton,
	TextField,
	Typography,
	useTheme,
} from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import AlertMsg from "../component/AlertMsg";
import { LoadingButton } from "@mui/lab";
import SlideList from "../component/SlideList";
import CloseIcon from "@mui/icons-material/Close";
import CalendarModal from "./CalenderModal";
import FormatHelper from "../helper/FormatHelper";

function WebAppSliderModal({ open, setOpen, domain }) {
	const theme = useTheme();
	const [sliders, setSliders] = useState(null);
	const [slideName, setSlideName] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loadingImg, setLoadingImg] = useState(false);
	const [uploadLogoMsg, setUploadLogoMsg] = useState(null);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [submitMsg, setSubmitMsg] = useState(null);
	const [title, setTitle] = useState("");
	const [link, setLink] = useState("");
	const [order, setOrder] = useState("");
	const [start, setStart] = useState("");
	const [startModal, setStartModal] = useState(false);
	const [startUnixDate, setStartUnixDate] = useState();
	const [end, setEnd] = useState("");
	const [endModal, setEndModal] = useState(false);
	const [endUnixDate, setEndUnixDate] = useState();
	const [error, setError] = useState({
		header: "",
		message: "",
	});

	const beforeUpload = file => {
		const isJpgOrPng =
			file.type === "image/jpeg" ||
			file.type === "image/jpg" ||
			file.type === "image/png";
		if (!isJpgOrPng) {
			return false;
		} else {
			return true;
		}
	};

	const handleChange = async info => {
		if (!beforeUpload(info.target.files[0])) {
			setUploadLogoMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "فایل صحیح انتخاب کنید",
			});
			return;
		}
		setLoadingImg(true);
		const token = localStorage.getItem("schoolToken");
		const data = new FormData();
		data.append("slide", info.target.files[0]);
		try {
			const response = await Axios.post(
				Constants.baseUrl + "/slide/upload",
				data,
				{
					headers: {
						authorization: "Bearer " + token,
					},
				}
			);
			const status = response.data.status;
			if (status === 202) {
				setUploadLogoMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "عکس بارگذاری شد",
				});
				setLoadingImg(false);
				setSlideName(response.data.result.file.name);
			} else {
				setUploadLogoMsg({
					type: false,
					header: "تلاش ناموفق",
					message: "بارگذاری عکس انجام نشد ، دوباره تلاش کنید",
				});
				setLoadingImg(false);
			}
		} catch (err) {
			setUploadLogoMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
			setLoadingImg(false);
		}
	};

	const handleSubmit = async () => {
		setLoadingSubmit(true);
		const token = localStorage.getItem("schoolToken");
		const data = {
			slide: {
				title: title,
				subtitle: null,
				image: slideName && slideName,
				link: link,
				type: "link",
				order: order || null,
				start: startUnixDate || null,
				end: endUnixDate || null,
			},
		};
		try {
			const response = await Axios.post(Constants.baseUrl + "/slide/add", data, {
				headers: {
					authorization: "Bearer " + token,
				},
			});
			const status = response.data.status;
			if (status === 201) {
				setSubmitMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "تبلیغ اضافه شد",
				});
				setLoadingSubmit(false);
				fetchSlideList();
				setSlideName(null);
				setUploadLogoMsg(null);
				setSubmitMsg(null);
				setTitle("");
				setLink("");
				setOrder("");
				setStart();
				setStartUnixDate();
				setEnd();
				setEndUnixDate();
			} else {
				setSubmitMsg({
					type: false,
					header: "تلاش ناموفق",
					message: "بارگذاری تبلیغ انجام نشد ، دوباره تلاش کنید",
				});
				setLoadingSubmit(false);
			}
		} catch (err) {
			setSubmitMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
			setLoadingSubmit(false);
		}
	};

	const fetchSlideList = async () => {
		try {
			setLoading(true);
			const response = await Axios.get(
				Constants.baseUrl + `/slide/list?domain=app.${domain}`,
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			if (response.data.status === 202) {
				setSliders(response.data.result.slides);
				setLoading(false);
			} else {
				setSliders(null);
				setLoading(false);
				setError({
					header: "خطا از طرف سرور",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setSliders(null);
			setLoading(false);
			setError({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	useEffect(() => {
		open && fetchSlideList();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<>
			<Dialog open={open} fullWidth maxWidth="sm">
				<Card sx={{ p: 2, overflowY: "auto" }}>
					<IconButton
						aria-label="close"
						onClick={() => {
							setOpen(false);
							setSlideName(null);
							setUploadLogoMsg(null);
							setSubmitMsg(null);
							setTitle("");
							setLink("");
							setOrder("");
						}}
						sx={{
							position: "absolute",
							right: 10,
							top: 10,
							color: "gray",
						}}>
						<CloseIcon />
					</IconButton>
					<Box className="d-flex-column">
						<Box
							className="d-flex"
							sx={{ [theme.breakpoints.down("sm")]: { flexDirection: "column" } }}>
							{uploadLogoMsg
								? !uploadLogoMsg.type && (
										<AlertMsg message={uploadLogoMsg} type={"error"} />
								  )
								: null}
							<IconButton
								sx={{
									borderRadius: "8px",
									border: "1px dashed #d9d9d9",
									width: "120px",
									height: "100px",
									my: 1,
									mx: 2,
								}}
								component="label">
								<Box className="d-flex-column" textAlign={"center"}>
									{loadingImg ? <LoopOutlinedIcon /> : <AddCircleOutlineOutlinedIcon />}
									<Typography mt={2} fontSize={16} fontWeight={"bold"}>
										بارگذاری عکس
									</Typography>
								</Box>
								<TextField
									type="file"
									hidden
									sx={{ display: "none" }}
									onChange={info => {
										handleChange(info);
									}}
									name="[licenseFile]"
								/>
							</IconButton>
							{slideName && (
								<img
									src={`${Constants.baseUrl}/slide/show/${slideName}`}
									width={200}
									height={120}
									style={{ objectFit: "contain" }}
									alt="slideImage"
								/>
							)}
						</Box>
						<Typography fontWeight={"bold"} mt={1}>
							اطلاعات تبلیغ
						</Typography>
						<Box
							className="d-flex"
							gap={1}
							sx={{ [theme.breakpoints.down("sm")]: { flexDirection: "column" } }}>
							<TextField
								name="title"
								value={title}
								onChange={event => {
									setTitle(event.target.value);
								}}
								placeholder="عنوان"
								variant="outlined"
								margin="normal"
								size="small"
							/>
							<TextField
								name="link"
								value={link}
								onChange={event => {
									setLink(event.target.value);
								}}
								placeholder="لینک"
								variant="outlined"
								margin="normal"
								size="small"
							/>
							<TextField
								name="order"
								value={order}
								onChange={event => {
									setOrder(event.target.value);
								}}
								placeholder="ترتیب"
								type="number"
								variant="outlined"
								margin="normal"
								size="small"
							/>
						</Box>
						<Box
							className="d-flex"
							gap={1}
							sx={{ [theme.breakpoints.down("sm")]: { flexDirection: "column" } }}>
							<Button
								onClick={() => {
									setStartModal(true);
								}}
								variant="outlined"
								sx={{ width: "220px", height: "40px", mt: 1 }}>
								{start && start !== null
									? FormatHelper.toPersianString(String(start.year)) +
									  "/" +
									  FormatHelper.toPersianString(String(start.month)) +
									  "/" +
									  FormatHelper.toPersianString(String(start.day))
									: "تاریخ شروع تبلیغ"}
							</Button>
							<Button
								onClick={() => {
									setEndModal(true);
								}}
								variant="outlined"
								sx={{ width: "220px", height: "40px", mt: 1 }}>
								{end && end !== null
									? FormatHelper.toPersianString(String(end.year)) +
									  "/" +
									  FormatHelper.toPersianString(String(end.month)) +
									  "/" +
									  FormatHelper.toPersianString(String(end.day))
									: "تاریخ پایان تبلیغ"}
							</Button>
						</Box>
						<LoadingButton
							loading={loadingSubmit}
							variant="contained"
							color="primary"
							sx={{ width: "100px", height: "40px", my: 1.5 }}
							onClick={handleSubmit}>
							ثبت
						</LoadingButton>
						{submitMsg ? (
							submitMsg.type ? (
								<AlertMsg message={submitMsg} type={"success"} />
							) : (
								<AlertMsg message={submitMsg} type={"error"} />
							)
						) : null}
					</Box>
					<hr />
					{loading ? (
						<Box className="d-flex-column" mt={2}>
							درحال دریافت اطلاعات
							<CircularProgress color="secondary" sx={{ my: 2 }} />
						</Box>
					) : sliders ? (
						<Box>
							<SlideList
								sliders={sliders}
								slideName={slideName}
								fetchSlideList={fetchSlideList}
							/>
						</Box>
					) : (
						<Box className="d-flex-column" mb={2}>
							<Typography mb={1}>{error.header}</Typography>
							<Typography mb={2}>{error.message}</Typography>
							<Button
								onClick={fetchSlideList}
								variant="contained"
								color="secondary"
								sx={{ color: "white" }}>
								تلاش مجدد
							</Button>
						</Box>
					)}
				</Card>
				<CalendarModal
					open={startModal}
					setOpen={setStartModal}
					setDate={setStart}
					setUnixDate={setStartUnixDate}
					start={true}
				/>
				<CalendarModal
					open={endModal}
					setOpen={setEndModal}
					setDate={setEnd}
					setUnixDate={setEndUnixDate}
					start={false}
				/>
			</Dialog>
		</>
	);
}

export default WebAppSliderModal;
